var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"eva-alert",class:_vm.classes},[_c('eva-icon',{attrs:{"value":_vm.icon,"color":"white"}}),_vm._v(" "),_c('eva-text',{attrs:{"text":_vm.label}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }